import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemText from '@material-ui/core/ListItemText';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ArrowDown from '@material-ui/icons/ArrowDropDown';
import DeleteIcon from '@material-ui/icons/Delete';
import { grey700 } from '@material-ui/core/colors';
import { withStyles } from '@material-ui/core/styles';

import { isMobile } from 'helpers/detect-mobile';

import {
  Avatar,
  ConfirmAction,
  injectIntl,
  HighlightText,
} from 'components';

const styles = theme => ({
  listItemText: {
    [theme.breakpoints.down('md')]: {
      paddingRight: 0,
    },
  },
  deleteBtn: {
    color: 'rgba(0, 0, 0, 0.54)',
    width: 140,
  },
  cancelBtn: {
    backgroundColor: '#eeeeee',
    borderRadius: 5,
  },
  cancelBtnLabel: {
    color: '#ff5722',
    fontSize: 14,
    fontWeight: 500,
  },
  resendBtn: {
    backgroundColor: '#4caf50',
    width: 80,
    marginRight: 5,
  },
  resendBtnLabel: {
    color: 'white',
    fontSize: 14,
    fontWeight: 500,
  },
  rolesBtn: {
    [theme.breakpoints.down('xs')]: {
      marginRight: 0,
    },
    marginRight: 20,
    fontSize: '1rem',
    fontWeight: 400,
    textTransform: 'none',
    padding: 0,
  },
  menu: {
    width: 400,
  },
  menuItem: {
    display: 'block',
    height: 'auto',
  },
});

class OrganizationLoginMemberList extends Component {
  static propTypes = {
    classes: PropTypes.shape({}).isRequired,
    info: PropTypes.shape({
      role: PropTypes.string,
    }),
    isMember: PropTypes.bool,
    roleMenuItems: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    searchText: PropTypes.string,

    formatMessage: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired,
    reinviteMember: PropTypes.func.isRequired,
    updateItem: PropTypes.func.isRequired,
  };

  static defaultProps = {
    info: {},
    isMember: false,
    searchText: '',
  };

  state = {
    anchorEl: null,
    currentRole: this.props.info.role || '',
  };

  getRoleTitle = (role, blockInfo) => {
    const customerblockedMessage = 'Customer Blocked. Permissions disabled.';
    const vendorblockedMessage = 'Vendor Blocked. Permissions disabled.';
    switch (role) {
      case 'admin':
        return 'Admin';
      case 'team-member':
        return 'Member';
      case 'store-manager':
        return !blockInfo || !blockInfo.store || blockInfo.store.isBlocked === false ? 'Permission to Update Storefront' : customerblockedMessage;
      case 'order-manager':
        return !blockInfo || !blockInfo.order || blockInfo.order.isBlocked === false ? 'Permission to Place Order' : vendorblockedMessage;
      default:
        return '';
    }
  };

  handleOpenRolesMenu = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleCloseRolesMenu = () => {
    this.setState({ anchorEl: null });
  };

  handleSelectRole = ({ role, permissions }) => {
    const { currentRole } = this.state;
    const { updateItem, info } = this.props;
    if (currentRole !== role) {
      const payload = {
        role,
        mPermissions: permissions.map(permission => ({
          permissionId: permission.id,
          writeAccess: true,
        })),
      };
      updateItem(payload, info.id); // the last parameter is Member ID
    }
    this.setState({ currentRole: role });
    this.handleCloseRolesMenu();
  };

  resend = () => {
    const { info, reinviteMember } = this.props;
    reinviteMember(info.id);
  };

  render() {
    const { anchorEl, currentRole } = this.state;
    const {
      classes,
      info,
      isMember,
      roleMenuItems,
      searchText,
      formatMessage,
      onDelete,
    } = this.props;

    const memberAccount = info.memberAccount || {};
    const profile = memberAccount.profile || info.profile || {};

    // do not show Store Manager or Order Manager if this item is not a distributor
    const isMemberOrganization = Boolean(memberAccount.currentRoleId);
    const menuItems = isMemberOrganization ? roleMenuItems.slice(2, 3) : roleMenuItems.slice(0, 2);

    let deleteMessage;
    if (info.pending) {
      deleteMessage = formatMessage('Do you really want to cancel this invitation?');
    } else {
      deleteMessage = formatMessage('Do you really want to remove this team member?');
    }
    const deleteButton = info.pending ? (
      <Button
        classes={{
          root: classes.cancelBtn,
          label: classes.cancelBtnLabel,
        }}
        variant="contained"
      >
        {formatMessage('Cancel Invite')}
      </Button>
    ) : (
      // <Button
      //   classes={{
      //     root: classes.deleteBtn,
      //   }}
      // >
      //   {formatMessage('Delete')}
      // </Button>
      <IconButton style={{ padding: 5, marginTop: -5 }}>
        <DeleteIcon color={grey700} />
      </IconButton>
    );

    const content = (
      <span className="sub-title">
        <span className="profile-info">
          <HighlightText
            highlight={searchText}
            text={isMemberOrganization ? profile.companyName : profile.firstName || profile.lastName ? !isMobile ? `${profile.firstName} ${profile.lastName}` : `${profile.lastName}` : ''}
            style={{ minWidth: '15%', marginRight: 10 }}
          />
          <span className="email">
            <HighlightText highlight={searchText} text={info.email} />
          </span>
        </span>
        {!isMember && (
          <span className="actions">
            {isMemberOrganization ? (
              <div className={classes.rolesBtn} style={{ marginRight: 47.5 }}>
                {formatMessage(this.getRoleTitle(currentRole, info.blockInfo))}
              </div>
            ) : (
              <Button
                aria-owns={anchorEl ? 'roles-menu' : null}
                aria-haspopup="true"
                classes={{ root: classes.rolesBtn }}
                onClick={this.handleOpenRolesMenu}
              >
                {formatMessage(this.getRoleTitle(currentRole))}
                <ArrowDown />
              </Button>
            )}
            <Menu
              anchorEl={anchorEl}
              anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
              transformOrigin={{ horizontal: 'right', vertical: 'top' }}
              className={classes.menu}
              id="roles-menu"
              onClose={this.handleCloseRolesMenu}
              open={Boolean(anchorEl)}
            >
              {menuItems.map(item => (
                <MenuItem
                  className={classes.menuItem}
                  key={item.title}
                  onClick={() => this.handleSelectRole(item)}
                  selected={item.role === currentRole}
                >
                  <div className="role-title">{formatMessage(item.title)}</div>
                  <div className="role-subtitle">{formatMessage(item.subtitle)}</div>
                </MenuItem>
              ))}
            </Menu>
            {info.pending && !isMobile && (
              <ConfirmAction
                action={this.resend}
                description={formatMessage('Do you really want to resend an invitation?')}
              >
                <Button
                  className="accept"
                  variant="contained"
                  classes={{
                    root: classes.resendBtn,
                    label: classes.resendBtnLabel,
                  }}
                >
                  {formatMessage('Resend')}
                </Button>
              </ConfirmAction>
            )}
            {!info.pending && (
              <div style={{ width: !isMobile ? 82 : 0 }} />
            )}
            <ConfirmAction
              action={() => onDelete()}
              description={deleteMessage}
            >
              {!isMobile ?
                deleteButton
              :
                <IconButton style={{ padding: 5, marginTop: -5 }}>
                  <DeleteIcon color={grey700} />
                </IconButton>
              }
            </ConfirmAction>
          </span>
        )}
      </span>
    );
    return (
      <ListItem className="organization-login-member-list">
        <ListItemAvatar>
          <Avatar
            highlighted
            src={profile.logoUrl}
            fullName={profile.firstName || profile.lastName ? `${profile.firstName} ${profile.lastName}` : '-'}
            className="organization-avatar"
          />
        </ListItemAvatar>
        <ListItemText
          classes={{
            root: classes.listItemText,
          }}
          primary={content}
        />
      </ListItem>
    );
  }
}

const wrappedOrganizationLoginMemberList = withStyles(styles)(
  injectIntl(OrganizationLoginMemberList));
wrappedOrganizationLoginMemberList.displayName = 'OrganizationLoginMemberList';

export default wrappedOrganizationLoginMemberList;
